import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Type = createReactComponent("Type", ["svg", defaultAttributes, [["polyline", {
  points: "4 7 4 4 20 4 20 7",
  key: "1r3p86"
}], ["line", {
  x1: "9",
  y1: "20",
  x2: "15",
  y2: "20",
  key: "1su926"
}], ["line", {
  x1: "12",
  y1: "4",
  x2: "12",
  y2: "20",
  key: "3nxra"
}]]]);
export default Type;